'use client';

import React from 'react';
import { ArrowDown, Maximize, ArrowUp, Eye, Trash2 } from 'lucide-react';

export default function DropdownMenu({
    itemId,
    isOpen,
    onClose,
    canDelete,
    onDelete,
    // onRename,
    onMove,
    onPreview,
    onSampleContent,
    isSubsection = false, // <--- Receive prop here
    canMoveUp = true,
    canMoveDown = true
}) {
    if (!isOpen) return null;

    return (
        <div className="absolute right-0 mt-2 w-60 bg-white border border-lightGrey rounded shadow-lg z-10">
            {/* Delete button - only shown for added sections (canDelete: true) */}
            {canDelete && (
                <button
                    type="button"
                    title={isSubsection ? 'Remove this subsection' : 'Remove this section'}
                    className="flex items-center gap-2 w-full px-4 py-2 text-base font-semibold text-red-600 hover:bg-red-50 text-left"
                    onClick={() => {
                        onDelete && onDelete(itemId);
                        onClose();
                    }}
                >
                    <Trash2 className="w-4 h-4 text-red-600" /> 
                    {isSubsection ? 'Delete Subsection' : 'Delete Section'}
                </button>
            )}
			{/* <button
				className="flex items-center gap-2 w-full px-4 py-2 text-base font-semibold text-dark-blue hover:bg-lightGrey/50 text-left"
				onClick={() => {
					onRename && onRename(itemId);
					onClose();
				}}
			>
				<Pencil className="w-4 h-4 text-dark-blue" /> Rename
				<Tooltip placement="left" content="Rename section">
					<InfoTooltip />
				</Tooltip>
			</button> */}
            
            {canMoveUp && (
                <button
                    type="button"
                    title="Move this section up within its group"
                    className="flex items-center gap-2 w-full px-4 py-2 text-base font-semibold text-dark-blue hover:bg-lightGrey/50 text-left"
                    onClick={() => {
                        onMove && onMove(itemId, 'up');
                        onClose();
                    }}
                >
                    <ArrowUp className="w-4 h-4 text-dark-blue" /> Move up
                </button>
            )}
            {canMoveDown && (
                <button
                    type="button"
                    title="Move this section down within its group"
                    className="flex items-center gap-2 w-full px-4 py-2 text-base font-semibold text-dark-blue hover:bg-lightGrey/50 text-left"
                    onClick={() => {
                        onMove && onMove(itemId, 'down');
                        onClose();
                    }}
                >
                    <ArrowDown className="w-4 h-4 text-dark-blue" /> Move down
                </button>
            )}
            <button
                type="button"
                title="Preview your current content for this section"
                className="flex items-center gap-2 w-full px-4 py-2 text-base font-semibold text-dark-blue hover:bg-lightGrey/50 text-left"
                onClick={() => {
                    onPreview && onPreview(itemId);
                    onClose();
                }}
            >
                <Maximize className="w-4 h-4 text-dark-blue" /> Full page preview
            </button>
            <button
                type="button"
                title="Open read-only guidance and example for this section"
                className="flex items-center gap-2 w-full px-4 py-2 text-base font-semibold text-dark-blue hover:bg-lightGrey/50 text-left"
                onClick={() => {
                    onSampleContent && onSampleContent(itemId);
                    onClose();
                }}
            >
                <Eye className="w-4 h-4 text-dark-blue" /> Section guide
            </button>
        </div>
    );
}